'use client';

import qs from 'qs';
import pick from 'lodash.pick'

type ParamsList = {
    [key: string]: any;
};

export default function addQueryParams(paramsToAdd: ParamsList): void {
    // Remove the ? otherwise it ends up in an object key.
    const params = qs.parse(window.location.search.replace('?', ''));
    let pickedParams = pick(params, paramsToAdd)

    if (!Object.keys(pickedParams).length) {
        pickedParams = paramsToAdd
    }

    if (pickedParams.sort === "recommended"){
        delete pickedParams.sort
    }
 
    history.pushState(
        null,
        '',
        `${window.location.pathname}?${qs.stringify(pickedParams)}`
    );
}
